export default "__VITE_PUBLIC_ASSET__7955322b__"